import axios from 'axios';
import config from '../config/config';

import {
    CASH_REGISTER_TICKET_REQUEST,
    CASH_REGISTER_TICKET_RECEIVE,
    CASH_REGISTER_TICKET_RECEIVE_ERROR,
    CASH_REGISTER_OPEN_CR_REQUEST,
    CASH_REGISTER_OPEN_CR_RECEIVE,
    CASH_REGISTER_OPEN_CR_RECEIVE_ERROR,
    CASH_REGISTER_OPEN_REQUEST,
    CASH_REGISTER_OPEN_RECEIVE,
    CASH_REGISTER_OPEN_RECEIVE_ERROR,
    CASH_REGISTER_REQUEST,
    CASH_REGISTER_RECEIVE,
    CASH_REGISTER_RECEIVE_ERROR,
    CASH_REGISTER_CHECK_IN_REQUEST,
    CASH_REGISTER_CHECK_IN_RECEIVE,
    CASH_REGISTER_CHECK_IN_RECEIVE_ERROR,
    CASH_REGISTER_LEAVE_CURRENT,
    CASH_REGISTER_CLOSE_REQUEST,
    CASH_REGISTER_CLOSE_RECEIVE,
    CASH_REGISTER_CLOSE_RECEIVE_ERROR,
    CASH_REGISTER_CLOSED_CR_REQUEST,
    CASH_REGISTER_CLOSED_CR_RECEIVE,
    CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR,
    CASH_REGISTER_CLOSE_TICKET,
    CASH_REGISTER_CHECK_OUT_REQUEST,
    CASH_REGISTER_CHECK_OUT_RECEIVE_ERROR,
    CASH_REGISTER_CHECK_OUT_RECEIVE
} from "../config/actions";
import swal from "sweetalert";
import {store} from "../store";

export function getTicket(id) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_TICKET_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/ticket/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                dispatch({
                    type: CASH_REGISTER_TICKET_RECEIVE,
                    data: response.data.ticket
                });
            } else {
                dispatch({
                    type: CASH_REGISTER_TICKET_RECEIVE_ERROR
                })
            }
        })
    }
}

export function getOpenCashRegisters() {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_OPEN_CR_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegisters/open', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: CASH_REGISTER_OPEN_CR_RECEIVE,
                    data: response.data
                });
            } else {
                dispatch({
                    type: CASH_REGISTER_OPEN_CR_RECEIVE_ERROR
                })
            }
        })
    }
}

export function getClosedCashRegisters() {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_CLOSED_CR_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegisters/closed', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: CASH_REGISTER_CLOSED_CR_RECEIVE,
                    data: response.data
                });
            } else {
                dispatch({
                    type: CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR
                })
            }
        })
    }
}

export function openCashRegister(name, fiskalyClient) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_OPEN_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister', {
            method: 'post',
            data: {
                name: name,
                fiskalyClient: fiskalyClient
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: CASH_REGISTER_OPEN_RECEIVE,
                        data: response.data
                    });
                    dispatch(getCashRegister(response.data.id));
                } else {
                    dispatch({
                        type: CASH_REGISTER_OPEN_RECEIVE_ERROR
                    })
                }
            }
        })
    }
}

export function closeCashRegister(id) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_CLOSE_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/close/' + id, {
            method: 'put'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: CASH_REGISTER_CLOSE_RECEIVE,
                        data: response.data
                    });
                    dispatch(getOpenCashRegisters());
                    dispatch(getClosedCashRegisters());
                } else {
                    dispatch({
                        type: CASH_REGISTER_CLOSE_RECEIVE_ERROR
                    })
                }
            }
        })
    }
}

export function getCashRegister(id) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/details/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: CASH_REGISTER_RECEIVE,
                    data: response.data
                });
            } else {
                dispatch({
                    type: CASH_REGISTER_RECEIVE_ERROR
                })
            }
        })
    }
}

export function leaveCashRegister() {
    return dispatch => {
        dispatch(getOpenCashRegisters());
        dispatch({
            type: CASH_REGISTER_LEAVE_CURRENT
        });
    }
}

export function checkInTicket(supporter, cashRegister, ean, gotAllFoodStamps, gotCarSticker, gotElectroBeer, ticketPrice, printShiftInfos, printerApiKey, items, stewardNumber) {
    return dispatch => {
        /*dispatch({
            type: CASH_REGISTER_CHECK_IN_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/accounting/', {
            method: 'post',
            data: {
                amount: parseFloat(ticketPrice),
                supporter: supporter,
                type: 'SUPPORTER_DEPOSIT_IN',
                comment: '',
                cashRegister: cashRegister
            }
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                dispatch(doCheckin(ean, cashRegister, gotAllFoodStamps, gotCarSticker, gotElectroBeer, printShiftInfos, printerApiKey));
            } else {
                dispatch({
                    type: CASH_REGISTER_CHECK_IN_RECEIVE_ERROR
                })
            }
        })*/
        dispatch(doCheckin(ean, cashRegister, gotAllFoodStamps, gotCarSticker, gotElectroBeer, printShiftInfos, printerApiKey, items, stewardNumber));
    }
}

export function checkOutSupporter(supporter, cashRegister, ean, gotPresent, ticketPrice) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_CHECK_OUT_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/accounting/', {
            method: 'post',
            data: {
                amount: parseFloat(ticketPrice) * -1,
                supporter: supporter,
                type: 'SUPPORTER_DEPOSIT_OUT',
                comment: '',
                cashRegister: cashRegister
            }
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                dispatch(doCheckout(supporter, cashRegister, gotPresent));
            } else {
                dispatch({
                    type: CASH_REGISTER_CHECK_OUT_RECEIVE_ERROR
                })
            }
        })
    }
}

export function doCheckin(ean, cashRegister, gotAllFoodStamps, gotCarSticker, gotElectroBeer, printShiftInfos, printerApiKey, items, stewardNumber) {
    return (dispatch, getState) => {
        //let period = getState().cashRegister.ticket.supporter.period.name;
        axios(config.server.endpoint + 'backend/cashRegister/checkIn/', {
            method: 'put',
            data: {
                ticket: ean,
                gotAllFoodStamps: gotAllFoodStamps,
                gotCarSticker: gotCarSticker,
                gotElectroBeer: gotElectroBeer,
                printShiftInfos: printShiftInfos,
                printerApiKey: printerApiKey,
                cashRegister: cashRegister,
                items: items ? items.map(i => ({
                    item: i.key,
                    project: store.getState().project.selectedProject.id,
                    value: i.value
                })) : [],
                stewardNumber: stewardNumber
            }
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                dispatch({
                    type: CASH_REGISTER_CHECK_IN_RECEIVE
                });
                dispatch(getCashRegister(cashRegister));
                swal({
                    title: 'Check-In Erfolgreich',
                    text: 'Der Check-In war erfolgreich',
                    icon: 'success'
                }).then();
                /*if(period && period.indexOf('during') !== -1) {
                    dispatch(printShiftInfos(ean));
                }*/
            } else {
                swal({
                    title: 'Check-In-Fehler',
                    text: 'Der Check-In konnte nicht durchgeführt werden! Bitte versuche es erneut (Seite neu laden) oder wende dich an den Support!',
                    icon: 'warning',
                    dangerMode: true
                }).then();
                dispatch({
                    type: CASH_REGISTER_CHECK_IN_RECEIVE_ERROR
                })
            }
        });
    }
}

export function doCheckout(supporter, cashRegister, gotPresent) {
    return (dispatch, getState) => {
        axios(config.server.endpoint + 'backend/cashRegister/checkOut/', {
            method: 'put',
            data: {
                supporter: supporter,
                gotPresent: gotPresent
            }
        }).then((response) => {
            if (response.status === 200 && response.data.success === true) {
                dispatch({
                    type: CASH_REGISTER_CHECK_OUT_RECEIVE
                });
                dispatch(getCashRegister(cashRegister));
            } else {
                dispatch({
                    type: CASH_REGISTER_CHECK_OUT_RECEIVE_ERROR
                })
            }
        });
    }
}

export function printShiftInfos(ean) {
    return dispatch => {
        axios(config.server.endpoint + 'backend/cashRegister/shiftInfos/pdf/' + ean, {
            method: 'get',
        }).then((response) => {
            if (response.status === 200) {
                let windowContent = response.data;
                let printWin = window.open('','','width=50,height=50');
                printWin.document.open();
                printWin.document.write(windowContent);
                printWin.document.close();
                printWin.focus();
                printWin.print();
                printWin.close();
            }
        });
    }
}

export function closeTicket() {
    return {
        type: CASH_REGISTER_CLOSE_TICKET
    }
}

/*export function createAccounting(amount, supporter, type, comment, cashRegister) {
    return dispatch => {
        dispatch({
            type: CASH_REGISTER_ADD_ACCOUNTING_REQUEST
        });
        axios(config.server.endpoint + 'backend/cashRegister/accounting/' + id, {
            method: 'post',
            data: {
                amount: amount,
                supporter: supporter,
                type: type,
                comment: comment,
                cashRegsiter: cashRegister
            }
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: CASH_REGISTER_ADD_ACCOUNTING_RECEIVE,
                    data: response.data
                });
            } else {
                dispatch({
                    type: CASH_REGISTER_ADD_ACCOUNTING_RECEIVE_ERROR
                })
            }
        })
    }
}*/
